import i18n from '@/i18n'

const getters = {
  getIsFetchingList: (state) => (state.isFetchingList),
  getIsFetchingStatus: (state) => (state.isFetchingStatus),
  getListUploadedFiles: (state) => (state.listUploadedFiles),
  getNextCursor: (state) => {
    return state.listNextCursor != null ? state.listNextCursor !== '' ? state.listNextCursor : null : null
  },
  getUploadFileStatus: (state) => (index) => (state.listUploadedFiles[index]),
  getUploadFileStatusInfo: (state) => (index) => {
    let infoText = ''
    if (state.listUploadedFiles[index].info != null) {
      state.listUploadedFiles[index].info.forEach((info, index) => {
        if (index !== 0) {
          infoText += info.comment
        } else {
          infoText += `, ${info.comment}`
        }
      })
      return null
    } else {
      return null
    }
  },
  getUploadFileStatusError: (state) => (index) => {
    let errorText = ''
    if (state.listUploadedFiles[index].errors != null) {
      errorText = state.listUploadedFiles[index].errors.map((error, index) => {
        return error.reason
      })
      return errorText
    } else {
      return state.listUploadedFiles[index].status === 'Errored' ? [i18n.t('uploads.no_logs_errored')] : null
    }
  }
}
export default getters
